import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import i18next from "i18next";

import {
    GET,
    newFetch
} from '../../helpers/fetch'
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from "../../config/index";
import PageShell from "../../components/UI/PageShell";
const { API_URL } = config;

const ChooseLanguage = ({ history }) => {
    const user = JSON.parse(localStorage.getItem('user'))
  const associate_id = JSON.parse(localStorage.getItem("user")).id;
  const myLanguage = JSON.parse(localStorage.getItem("user")).language;
  const [associate, setAssociate] = useState(null)
  const token = localStorage.getItem("token");

  const [language, setLanguage] = useState("");

  const languageHandler = (e) => setLanguage(e.target.value);

  const submitHandler = async (e) => {
    e.preventDefault();
    let url = `${API_URL}/associate/${associate_id}/select-language`;

    try {
      let data = {
        language,
      };

      let response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        withCredentials: true,
        mode: "cors",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
        },
      });

      let json = await response.json();

      if (response.ok) {
        ToastUtil.success("Language successfully updated.");
      } else {
        ToastUtil.error(json.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const periodType = [
    { label: "English", value: "en" },
    { label: "Mandarin (普通)", value: "chi" },
  ];

  const handlePeriodTypeSelection = (value) => {
    i18next.changeLanguage(value)
    setLanguage(value);
  };

  const fetchUser = async () => {
    let api_path = "/associate/aboutme";
    let response = await newFetch(GET, api_path);

    response.success && setAssociate(response.data);
  };

  useEffect(() => {
    if (user) {
      fetchUser();
    }
  }, []);

  useEffect(() => {
    associate && associate?.language && setLanguage(associate.language);
  }, [associate]);

  return (
    <PageShell
      title="Choose language"
      eyebrow="Preferences"
      description="Select the language used throughout your employee workspace."
      backTo="/setting"
    >
      <form className="portal-form-card" onSubmit={(e) => submitHandler(e)}>
          <div className="portal-form-section-title">
            <h2>Display language</h2>
            <p>Your selection is saved to your associate profile.</p>
          </div>
          <div className="portal-language-grid">
            {periodType.map((type, index) => (
              <label className="portal-language-option" key={index}>
                <input
                  type="radio"
                  name="itemType"
                  id={`itemType-${index}`}
                  value={type.value}
                  checked={type.value === language}
                  onChange={({ target: { value } }) =>
                    handlePeriodTypeSelection(value)
                  }
                />
                <span className="portal-language-option__check" aria-hidden="true" />
                <span>{type.label}</span>
              </label>
            ))}
          </div>

          <button
            type="submit"
            className="btn btn-design btn-brand btn-block mt-4"
          >
            Save Changes
          </button>
      </form>
    </PageShell>
  );
};

export default withRouter(ChooseLanguage);
